<div class="container-custom-header">
    <div class="container-fluid animate__animated animate__fadeIn">
        <div class="">
            <div class="row align-items-center mt-5">
                <div class="col-12">
                    <div class="d-flex" [ngClass]="!isMobileXL() ? 'justify-content-start' : 'justify-content-center'">
                        <p class="mat-card-header-titulo">
                            {{Etiquetas.Titulo}}</p>
                    </div>
                </div>

                      <div class="col-12 order-xxl-3 order-xl-3 order-lg-3 mt-4 mb-4">
                    <mat-divider></mat-divider>
                </div>

            </div>

        </div>

    </div>
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">
            <div class="mat-toolbar-custom">
                <mat-toolbar>
                    <mat-toolbar-row>

                        <button  [disabled]="loadingReporte" mat-flat-button
                            color="accent" (click)="cReporteExcel()">
                            <mat-icon *ngIf="!loadingReporte">download</mat-icon>
                            {{botonReporte}}
                        </button>

                        <span class="mat-toolbar-row-separador"></span>

                        <button  *ngIf="!isInRole('CONSULTOR')"
                            (click)="dialogUsuario(1,null)" mat-flat-button
                            color="accent">{{Etiquetas.BotonAUsuario}}</button>

                    </mat-toolbar-row>

                </mat-toolbar>

            </div>

        </div>
    </div>
</div>


<div class="container-custom-content">
    <div class="container-fluid">
        <div class="row align-items-center justify-content-evenly">


            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">


                <mat-form-field color="accent-darker" appearance="standard">
                    <mat-label>{{Etiquetas.Buscar}}</mat-label>
                    <input matInput (keyup)="applyFilter($event)" placeholder="Usuario, Nombre, etc..." #input>
                </mat-form-field>
                <div>
                    <table class="animate__animated animate__fadeIn" mat-table matTableResponsive multiTemplateDataRows
                        [dataSource]="dataSource" matSort matSortActive="nombreApellido" matSortDirection="asc">

                        <ng-container matColumnDef="acciones">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Acciones}} </th>
                            <td mat-cell data-label="Acciones" *matCellDef="let usuario">
                                <div>
                                    <button *ngIf="isInRole('CONSULTOR')" matTooltip="{{Tooltips.Ver}}"
                                        (click)="dialogUsuario(2,usuario)" mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">visibility</mat-icon>
                                    </button>
                                    <button *ngIf="!isInRole('CONSULTOR')" matTooltip="{{Tooltips.Editar}}"
                                        (click)="dialogUsuario(2,usuario)" mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">edit</mat-icon>
                                    </button>

                                    <button *ngIf="!isInRole('CONSULTOR')" matTooltip="{{Tooltips.Eliminar}}"
                                        (click)="eliminarUsuario(usuario)" mat-icon-button color="primary-darker">
                                        <mat-icon color="accent-darker">delete</mat-icon>
                                    </button>

                                </div>

                            </td>
                        </ng-container>

                        <ng-container matColumnDef="userName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.UserName}}
                            </th>
                            <td mat-cell *matCellDef="let u">
                                {{u.userName}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="nombreApellido">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Nombre}}
                            </th>
                            <td mat-cell *matCellDef="let u">
                                {{u.nombreApellido}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="rol">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> {{Etiquetas.Headers.Rol}}
                            </th>
                            <td mat-cell *matCellDef="let u">
                                {{u.rol.name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="habilitacion">
                            <th mat-header-cell *matHeaderCellDef> {{Etiquetas.Headers.Habilitacion}}
                            </th>
                            <td mat-cell *matCellDef="let u">
                                <div>
                                    <mat-icon color="accent-darker">{{ u.habilitacion ?
                                        'check_box' :
                                        'check_box_outline_blank' }}
                                    </mat-icon>
                                </div>
                            </td>
                        </ng-container>


                        <ng-container matColumnDef="expand">
                            <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                            <td mat-cell *matCellDef="let u">
                                <div>
                                    <button mat-icon-button aria-label="expand row"
                                        (click)="(expandedElement = expandedElement === u ? null : u); $event.stopPropagation(); onRowExpand(u)">
                                        <mat-icon *ngIf="expandedElement !== u">keyboard_arrow_down</mat-icon>
                                        <mat-icon *ngIf="expandedElement === u">keyboard_arrow_up</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="expandedDetail">
                            <td mat-cell *matCellDef="let u" [attr.colspan]="displayedColumnsExpand.length">
                                <div class="example-element-detail"
                                    [@detailExpand]="u == expandedElement ? 'expanded' : 'collapsed'">
                                    <div [ngClass]="isMobileXL() ? 'pt-3 pb-3' :  'pt-2 pb-2'">

                                        <div class="container-fluid d-flex" style="text-align: left;">
                                            <div>
                                                {{paisesUsuario}}
                                            </div>

                                        </div>
                                        <div class="container-fluid d-flex" style="text-align: left;">
                                            <div>
                                                {{divisionesUsuario}}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumnsExpand"></tr>
                        <tr class="example-element-row" [class.example-expanded-row]="expandedElement === u" mat-row
                            *matRowDef="let u; columns: displayedColumnsExpand;">
                        </tr>
                        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                        <tr class="mat-row tr-sin-resultados" *matNoDataRow>
                            <td class="mat-cell" [attr.colspan]="displayedColumnsExpand.length">
                                {{Etiquetas.SinResultados}}
                            </td>
                        </tr>
                    </table>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons>
                    </mat-paginator>
                </div>

            </div>

        </div>

    </div>

</div>